import { axiosInstance } from "./interceptor";
const COLLECTION_URL = "/blog";
const LIST_URL = COLLECTION_URL + "/";

async function apiBlogs() {
  return await axiosInstance().get(LIST_URL);
}

export default { apiBlogs };
